module.exports = __webpack_public_path__ + "fonts/lato.586ec8dc.woff";